import i18n from "../../i18n/i18n"

export enum CodeOfConductStatusType {
    NotSet = 0,
    Approved = 1,
    Rejected = 2
}

// tslint:disable-next-line:no-namespace
export namespace CodeOfConductStatusType {
	export function displayName(type: CodeOfConductStatusType) {
		const values: { [index: number]: string } = {
			1: "ENUM_CODEOFCONDUCTSTATUSTYPE_APPROVED",
			2: "ENUM_CODEOFCONDUCTSTATUSTYPE_REJECTED"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(CodeOfConductStatusType[type])
		}
	}
}
